export default __webpack_public_path__ + "static/media/warningIcon.0828b9f0.svg";